<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title E-Mail Vorlagen
    .sub-headline Hier können Sie alle E-Mail Vorlagen verwalten.

    .margin-top
      h2.title.is-6 Mögliche Werte
      .email-values
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Datum Heute}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Anreise}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Abreise}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Gast Begrüßung}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Gast Anrede}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Gast Vorname}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Gast Nachname}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Eigentümer Begrüßung}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Benutzer Vorname}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Benutzer Nachname}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Objekt Name}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Objekt Code}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Mietvertragsnummer}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Angebotsliste}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Erwachsene}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Kinder}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Übernachtungen}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Objektmiete}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Gesamtmiete}}
        b-tag(type="is-text" size="is-medium") 
          div(v-pre) {{Offener Betrag}}

    .rent-object-features-wrapper.margin-top
      b-tabs(vertical)
        b-tab-item(icon="file-document-outline" v-for="template, idx in emailTemplates" :label="getName(template.uuid)")
          .form.w960
            .card
              .top
                h2.title.is-6 {{getName(template.uuid)}}
                ValidationObserver(v-slot="{ handleSubmit }", ref="form")
                  ValidationProvider(
                    name="Betreff",
                    rules="required|min:2",
                    v-slot="{ errors, valid }")
                    b-field(
                      label="Betreff",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0], 'is-success': valid }",
                      :message="errors")
                      b-input(v-model="template.subject")
                  ValidationProvider(
                    name="E-Mail Text",
                    rules="required|min:8",
                    v-slot="{ errors, valid }")
                    b-field(
                      label="E-Mail Text",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0], 'is-success': valid }",
                      :message="errors")
                      vue-editor(v-model="template.body" :editorOptions="editorOptions")
                        
                  .button-wrapper.margin-top.right
                    b-button(
                      type="is-light",
                      @click="$router.push({ name: 'Settings' })") Abbrechen
                    b-button(
                      type="is-primary",
                      @click="handleSubmit(updateEmailTemplate(idx))") Speichern
</template>

<script>
export default {
  data() {
    return {
      emailTemplates: [],
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  methods: {
    updateEmailTemplate(i) {
      this.$store.dispatch("emailTemplates/update", this.emailTemplates[i]);
    },
    getName(uuid) {
      if (uuid === 'OFFER_EMAIL') {return 'Angebot'}
      else if (uuid === 'CONTRACT_EMAIL') {return 'Mietvertrag'}
      else if (uuid === 'CONTRACT_OWNER_EMAIL') {return 'Mietvertrag an Eigentümer'}
      else if (uuid === 'CANCEL_EMAIL') {return 'Stornierungsbestätigung'}
      else if (uuid === 'CANCEL_INVOICE_EMAIL') {return 'Stornierungsabrechnung'}
      else if (uuid === 'PAYMENT_EMAIL') {return 'Zahlung'}
      else if (uuid === 'PAYMENT_REMINDER_1_EMAIL') {return 'Erinnerung'}
      else if (uuid === 'PAYMENT_REMINDER_2_EMAIL') {return 'Mahnung'}
      else if (uuid === 'CONTRACT_BACK_EMAIL') {return 'Mietvertrag bestätigt'}
      else if (uuid === 'BOOKING_EMAIL') {return 'Buchungsanfrage'}
      else if (uuid === 'SETTLEMENT_EMAIL') {return 'Eigentümerabrechnung'}
      else if (uuid === 'BOOKING_REQUEST_EMAIL') {return 'Text Anfrage'}
      else if (uuid === 'FINANCE_INVOICE_OWNER_EMAIL') {return 'Rechnung Eigentümer'}
      else if (uuid === 'FINANCE_INVOICE_CUSTOMER_EMAIL') {return 'Rechnung Gast'}
      else if (uuid === 'FALLBACK_ARRIVAL_EMAIL') {return 'Anreise (Standard)'}
      else if (uuid === 'CUSTOM_ARRIVAL_EMAIL_1') {return process.env.VUE_APP_WEBSITE.includes('boltenhagen') ? 'Anreise VB' : 'Anreise (Muster 1)'}
      else if (uuid === 'CUSTOM_ARRIVAL_EMAIL_2') {return process.env.VUE_APP_WEBSITE.includes('boltenhagen') ? 'Anreise SP' : 'Anreise (Muster 2)'}
      else if (uuid === 'CUSTOM_ARRIVAL_EMAIL_3') {return process.env.VUE_APP_WEBSITE.includes('boltenhagen') ? 'Anreise WB' : 'Anreise (Muster 3)'}
      else if (uuid === 'CUSTOM_ARRIVAL_EMAIL_4') {return process.env.VUE_APP_WEBSITE.includes('boltenhagen') ? 'Anreise RP' : 'Anreise (Muster 4)'}
      else if (uuid === 'CUSTOM_ARRIVAL_EMAIL_5') {return process.env.VUE_APP_WEBSITE.includes('boltenhagen') ? 'Anreise MB' : 'Anreise (Muster 5)'}
      else if (uuid === 'CUSTOM_ARRIVAL_EMAIL_6') {return process.env.VUE_APP_WEBSITE.includes('boltenhagen') ? 'Anreise FR' : 'Anreise (Muster 6)'}
      else if (uuid === 'CUSTOM_ARRIVAL_EMAIL_7') {return process.env.VUE_APP_WEBSITE.includes('boltenhagen') ? 'Anreise GT' : 'Anreise (Muster 7)'}
      else {return 'Unbekanntes Template - Kontaktieren Sie Ihren Admin'}
    }
  },
  async mounted() {
    this.emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
  },
};
</script>

<style lang="scss" scoped>
.email-values {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>